import React from "react";

import ExifOrientationImg from 'react-exif-orientation-img'
import Compressor from 'compressorjs'
import defaultImage from "assets/img/default-picture-file.png";
import Delete from "@material-ui/icons/Delete";
import Attachment from "@material-ui/icons/Attachment";
import { ReactSortable } from "react-sortablejs";

const OrientationImg = ExifOrientationImg

const ExifRestorer = require('components/44/ExifRestorer.js').default;

//**dataURL to blob**
function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
}

//**blob to dataURL**
/*function blobToDataURL(blob, callback) {
    var a = new FileReader();
    a.onload = function(e) {callback(e.target.result);}
    a.readAsDataURL(blob);
}*/

class FileUpload extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pouchDB_imageType: 'base64',
      img: undefined,
      file: undefined,
      files: [],
      label: this.props.label || '',
      helperText: this.props.helperText,
      mimeTypes: this.props.mimeTypes,
      previewImageTypes: 'jpg,jpeg,png,gif,webp',
      max: this.props.max || 1,
      imagePreviewUrl: defaultImage,
      lastChanged: Date.now(),
      pdfIconBase64: 'data:image/png;base64,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'
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    /*this.handleSubmit = this.handleSubmit.bind(this);*/
  }

  componentDidMount(){
    let filesObj = this.props.files
    let file = undefined
    let _this = this

    //return true;
    /*if(typeof filesObj == 'object'){
      file = filesObj
      console.log('hier1');
      this.prepareFile(file)
    }*/

    if(typeof filesObj == 'object') {
      if(Object.keys(filesObj).length > 15){
        file = filesObj
        _this.prepareFile(file)
      }else{
        Object.keys(filesObj).forEach(function(key) {
          file = filesObj[key]
          _this.prepareFile(file, key)
        });
      }
    }
  }

  prepareFile(file, key=false){
    key = key || file.name
    let _this = this
    //let filesObj = this.props.files
    let files = []

    if(typeof file !== 'undefined'){
      let dataUrl = '#'
      let base64 = file.data //this.resizedataURL(file.data)
      let contentType = file.mime_type || file.content_type || file.type || 'image/jpeg'

      if(base64){
        dataUrl = 'data:'+contentType+';base64,'+base64
      }

      let fileEnding = contentType.split('/')[1];

      // change preview icon for non images
      if(!_this.state.previewImageTypes.split(',').includes(fileEnding)){
        if(fileEnding === "pdf"){
          dataUrl = _this.state.pdfIconBase64
        }
      }

      if(typeof file.thumbnail_url !== 'undefined') {
        file.imagePreviewUrl = file.thumbnail_url
        files.push(file)
        _this.setState({files: files});
      }else if(typeof file.sizes !== 'undefined' && typeof file.sizes.thumbnail !== 'undefined'){
        file.imagePreviewUrl = file.sizes.thumbnail
        files.push(file)
        _this.setState({files: files});
      }else{
        file.imagePreviewUrl = dataUrl
        file.name = key
        files.push(file)
        _this.setState({
          files: files
        },function(){
          if (_this.props.onChange) {
            _this.props.onChange(files);
          }
        });
      }

    }else{
      console.debug('file not found:', file)
    }
  }

  handleImageDelete(e, key, prop) {
    e.preventDefault();

    let _this = this
    let files = this.state.files

    if(typeof key !== 'undefined'){
      files.splice(key, 1)
      _this.setState({
        files: files
      },function(){
        if (_this.props.onChange) {
          _this.props.onChange(files);
        }
      });
    }else{
    }
  }

  handleImageChange(e, key, prop) {
    e.preventDefault();

    let _this = this
    let files = this.state.files
    let newFiles = e.target.files;

    Object.values(newFiles).forEach(function(origfile) {
      let file = {}

      let fileEnding = origfile.type.split('/')[1];

      if(!_this.state.mimeTypes.split(',').includes(fileEnding)){
        console.debug('This mimeType ('+fileEnding+') is not allowed! Allowed are '+ _this.state.mimeTypes);
      } else {
        if(_this.state.previewImageTypes.split(',').includes(fileEnding)){
          console.debug('This mimeType ('+fileEnding+') is a valid imageType! Allowed are '+ _this.state.previewImageTypes);

          new Compressor(origfile, {
            quality: 0.6,
            minWidth: 800,
            minHeight: 600,
            maxWidth: 1600,
            maxHeight: 1000,
            success(compressedFile) {
              //console.log('2. sizeCompressedImage', getImageSize(result))
              //console.log('compressedImage', compressedFile)

              /*
               * Handle File Reader START
               */
              let reader = new FileReader();

              reader.onloadend = () => {
                let dataUrl = reader.result
                let data = undefined
                // eslint-disable-next-line
                let dataSmall = undefined
                //let blob = undefined
                // eslint-disable-next-line
                let base64 = undefined

                if(typeof dataUrl === 'string'){
                  //base64 = _this.resizedataURL(data)

                  // eslint-disable-next-line
                  let dataUrlSmall = _this.resizedataURL(dataUrl, function(dataUrlSmall){

                    // lastChanged is used to force update OrientationImg
                    file.lastChanged = Date.now()
                    file.imagePreviewUrl = dataUrl
                    //_this.setState({ imagePreviewUrl: dataUrlSmall, lastChanged: Date.now() })
                    //console.log('callback after dataUri shrink', dataUrlSmall)

                    data      = dataUrl.split('base64,')[1]
                    base64    = data
                    dataSmall = dataUrlSmall.split('base64,')[1]

                    if(_this.state.pouchDB_imageType==='blob'){
                      data = dataURLtoBlob(dataUrl)
                    }

                    file.name         = origfile.name
                    file.size         = origfile.size
                    file.type         = origfile.type
                    file.title        = origfile.title || ''
                    file.content_type = origfile.type
                    file.data = data

                    if(typeof key !== 'undefined'){
                      files[key] = file
                    }else{
                      files.push(file)
                    }

                    _this.setState({
                      files: files
                    },function(){
                      if (_this.props.onChange) {
                        _this.props.onChange(_this.formatFilesObject(files));
                      }
                    });

                  }, 100, 75, key)
                }
              };

              // erzeugt: data:image/jpeg;base64
              reader.readAsDataURL(compressedFile);

              /*
               * Handle File Reader ENDE
               */
            },
            error(err) {
              console.log(err.message);
            },
          });

        }else {
          // For non ImageFileType like PDF
          console.debug('This mimeType ('+fileEnding+') is not a valid imageType! ImageTypes are '+ _this.state.previewImageTypes);

          /*
           * Handle File Reader START
           */
          let reader = new FileReader();

          reader.onloadend = () => {
            let dataUrl = reader.result
            let data = undefined
            // eslint-disable-next-line
            let dataSmall = undefined
            //let blob = undefined
            // eslint-disable-next-line
            let base64 = undefined

            let fileEnding = origfile.type.split('/')[1];

            // change preview icon for non images
            if(!_this.state.previewImageTypes.split(',').includes(fileEnding)){

              if(fileEnding === "pdf"){
                file.imagePreviewUrl = _this.state.pdfIconBase64
              }
            }

            // lastChanged is used to force update OrientationImg
            file.lastChanged = Date.now()
            //_this.setState({ imagePreviewUrl: dataUrlSmall, lastChanged: Date.now() })
            //console.log('callback after dataUri shrink', dataUrlSmall)

            data = dataUrl.split('base64,')[1]
            base64 = data
            dataSmall = undefined

            if (_this.state.pouchDB_imageType === 'blob') {
              data = dataURLtoBlob(dataUrl)
            }

            file.name = origfile.name
            file.size = origfile.size
            file.type = origfile.type
            file.title = origfile.title || ''
            file.content_type = origfile.type
            file.data = data

            //console.debug('Bilddaten', origfile)

            if (typeof key !== 'undefined') {
              files[key] = file
            } else {
              files.push(file)
            }

            _this.setState({
              files: files
            }, function () {
              if (_this.props.onChange) {
                _this.props.onChange(_this.formatFilesObject(files));
              }
            });
          }

          //console.log("origfile2", origfile)
          // erzeugt: data:application/pdf;base64
          reader.readAsDataURL(origfile);
        };

      } // endif mimeTypes-Check
    });
  }

  arrayMoveElement(arr, old_index, new_index) {
      if (new_index >= arr.length) {
          var k = new_index - arr.length + 1;
          while (k--) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; // for testing
  };

  handleImageSort(e) {
    if(typeof e.newIndex === 'number' && typeof e.oldIndex === 'number'){
      let files = this.state.files
      files = this.arrayMoveElement(files, e.oldIndex, e.newIndex)

      if (this.props.onChange) {
        this.props.onChange(this.formatFilesObject(files));
      }
    }
  }

  handleImageText(e, k, v){
    /*console.debug('handleImageText', e.target.value);*/
    console.log(k,v);
    let files = this.state.files
    files[k].title = e.target.value;
    /*if (this.props.onChange) {
      this.props.onChange(files);
    }*/
    this.setState({
      files: files
    },function(){
      if (this.props.onChange) {
        this.props.onChange(files);
      }
    });
  }

  /*handleSubmit(e) {
    e.preventDefault();
    console.log('handleSubmit: this.state.file', this.state.file);
  }*/

  resizedataURL(datas, callback = undefined, wantedWidth = 100, wantedHeight = 75, key = '') {
    // We create an image to receive the Data URI
    var img = document.createElement('img');

    // When the event "onload" is triggered we can resize the image.
    img.onload = function () {
      // We create a canvas and get its context.
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');

      // debug current size
      var ratio = this.width/this.height

      wantedHeight = wantedWidth/ratio

      // We set the dimensions at the wanted size.
      canvas.width = wantedWidth;
      canvas.height = wantedHeight;

      // We resize the image with the canvas method drawImage();
      ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

      var dataURI = canvas.toDataURL();
      dataURI = ExifRestorer.restore(datas.replace('data:', ''), dataURI);


      if(typeof callback === 'function'){
        callback(dataURI)
      }
    };

    // We put the Data URI in the image's src attribute
    img.src = datas;
  }

  formatFilesObject(files_ary, name= false) {
    let attachments = {}
    let file
    let _this = this

    if(typeof files_ary !== 'undefined' && Object.keys(files_ary).length){
      let i = 0
      Object.keys(files_ary).forEach(function(key) {
        file = files_ary[key]
        if(!name){
          name = file.name
        }
        //console.log('images.forEach file=', file);

        if(typeof file !== "undefined"){
          let filename = _this.secureFilename(key, i, file, name)
          file.name = filename

          if(attachments[filename]){
            let filename = _this.filenameByName(key, i, file, name)
            file.name = filename
            // Index existiert schon, ändern
            //console.log('Attachment-Index exitiert schon, rename to:', filename)
            attachments[filename] = file
          }else{
            attachments[filename] = file
          }

          /*attachments[filename] = {
            name: filename,
            size: size,
            content_type: file.type,
            type: file.type,
            data: file.data
          }*/
        }
        i++;
      });
    }
    return attachments;
  }

  secureFilename(key, i, file, productName){
    let filename = file.name || key
    // image.jpg is a default iOS Name, we have to rename it
    if(filename === 'image.jpg') {
      filename = this.filenameByName(key, i, file, productName, 'file')
    }
    // Remove invalid trailing _
    if(filename.charAt(0)==='_'){
      filename = filename.substr(1);
    }
    //console.log('secureFilename', filename)
    return filename
  }

  filenameByName(key, i, file, productName, prefix = 'img'){
    let type = (file.type || file.content_type).replace('jpeg', 'jpg')

    // Originalfilename und Fallback Filename mit Timestamp
    let filename = file.name || key || ('img-'+Date.now()+'.'+type.split('/').pop())

    // Filename by Artikelname deaktviert, da in der API aktuell nicht überprüft wird ob unter diesem Namen schon ein Bild existiert, wenn ja wird dieser genommen und überschrieben?!
    if(false || productName.length > 2){
      // Filename by Artikelname
      let secName = productName.replace(' ', '-').replace(/(?!\.[^.]+$)\.|[^\w-]+/g, '')
      filename = prefix+i+'-'+secName+'.'+type.split('/').pop()
    }else{
      // Uniq Filename by Timestamp
      filename = prefix+i+'-'+Date.now()+'.'+type.split('/').pop()
    }
    if(filename.charAt(0)==='_'){
      filename = filename.substr(1);
    }
    return filename
  }

  render() {
    const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    return (
      <div>
        <p style={{marginTop:10, marginBottom:0}}>{this.state.label}</p>
        {this.state.helperText.length > 0 ? <p style={{marginTop:0, marginBottom:0, fontSize:'11px'}}>{this.state.helperText}</p> : ''}
        <ReactSortable onEnd={(e) => this.handleImageSort(e)} list={this.state.files} setList={(newState) => function(){ /*console.debug('setList', newState);*/ }} >
          {this.state.files.map((prop, key) => {
          // let prop = value[1]
          // {Object.entries(this.state.files).map((value, key) => {
          if (iOS) {
            return (
              <div key={key+'-wrapper'} className="picture-container ios" style={{display:'inline-block'}}>
                <div className="picture" title={prop.name || ''}>
                  <img id={key===0 ? 'mainimage' : 'image-'+key}
                    key={'oimg-'+key+'-'+prop.lastChanged}
                    src={prop.imagePreviewUrl}
                    className="picture-src"
                    //crossOrigin="anonymous"
                    alt={prop.name || ''}
                  />
                  <input type="file" accept="image/*,application/pdf" onChange={(e) => this.handleImageChange(e,key,prop)} />
                </div>
                <div className="description"><input type="text" placeholder="Beschreibung" onChange={(e) => this.handleImageText(e,key,prop)} value={prop.title || ''} /></div>
                <h6 onClick={(e) => this.handleImageDelete(e,key,prop)} className="deleteBtn"><Delete /> löschen</h6>
              </div>
            );
          }else{
            return (
              <div key={key+'-wrapper'} className="picture-container" style={{display:'inline-block'}}>
                <div className="picture" title={prop.name || ''}>
                  <div className="filename">{prop.name || ''}</div>
                  <OrientationImg id={Number(key)===0 ? 'mainimage' : 'image-'+key}
                    key={'oimg-'+key+'-'+prop.lastChanged}
                    src={prop.imagePreviewUrl}
                    className="picture-src"
                    //crossOrigin="anonymous"
                    alt={prop.name || ''}
                  />
                  <input type="file" accept="image/*,application/pdf" onChange={(e) => this.handleImageChange(e,key,prop)} />
                </div>
                <div className="description"><input type="text" placeholder="Beschreibung" onChange={(e) => this.handleImageText(e,key,prop)} value={prop.title || ''} /></div>
                <h6 onClick={(e) => this.handleImageDelete(e,key,prop)} className="deleteBtn"><Delete /> löschen</h6>
              </div>
            );
          }
        })}
        </ReactSortable>
        <div key="new-image" className="picture-container" style={{ marginTop: -5, display: this.state.files.length < (this.state.max || 1) ? 'inline-block' : 'none'}}>
          <div className="picture">
            <OrientationImg id="newimage"
              key={'oimg-'+this.state.lastChanged}
              src={defaultImage}
              className="picture-src newimage"
              //crossOrigin="anonymous"
              alt="choose new image"
            />
            <input type="file" accept="image/*,application/pdf" multiple onChange={e => this.handleImageChange(e)} />
          </div>
          <h6 className="deleteBtn"><Attachment /> wählen</h6>
        </div>
      </div>
    );
  }
}

export default FileUpload;
